import ModalController from "webmodals/modal.controller";
import $session from "servicestack/session";
import ServiceBus from "servicestack/service-bus";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import ActivityPrompt from "emun.activity/activity-prompt";
import orderConfig from 'emun.order/order.config';

class OrderQuestionsPromptController extends ModalController {
	constructor($uibModalInstance, options) {
		super($uibModalInstance);
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.orderConfig = orderConfig;
		$ctrl.bus = new ServiceBus();
		$ctrl.title = options.title || "Order Questions...";
		$ctrl.subTitle = options.subTitle;
		$ctrl.id = options.orderId || options.cartId || options.id || 0;
		$ctrl.retailerId = options.retailerId;
		$ctrl.tagsPopulated = false;
		var retailerQuery = new AutoQuery({
			url: "QueryRetailers.json?Id=" + $ctrl.retailerId,
			orderBy: "CompanyName",
			autoLoad: true,
			onLoaded: args => {
				if (args.total === 0) {
					return alert("Could not find: " + $ctrl.customerId);
				}
				$ctrl.customer = args.first;
				//$ctrl.customer.tags.forEach(function (tag) {
				//	if (!tag.value) $ctrl.tagsPopulated = false;
				//});
			}
		});
		this.activities = new AutoQuery({
			url:
				"QueryActivities.json?startDateGreaterThan=" +
				moment().format("MM/DD/YYYY") +
				"&retailerId=" +
				$ctrl.retailerId,
			orderBy: "StartDate",
			autoLoad: true,
			pageSize: 10,
			onLoaded: function (args) {
				if (args.total > 0) {
					$ctrl.activity = args.results[0];
				}
				$ctrl.contacts = new AutoQuery({
					url:
						"QueryRetailerContacts.json?active=true&retailerId=" +
						$ctrl.retailerId,
					orderBy: "Name",
					autoLoad: true,
					onLoaded: function (args) {
						if (args.total === 1) {
							$ctrl.contact = args.results[0];
							if ($ctrl.activity) $ctrl.activity.contact = $ctrl.contact.name;
						}
						if ($ctrl.activity) {
							args.results.forEach(function (contact) {
								if (contact.name === $ctrl.activity.contact) {
									$ctrl.contact = contact;
									$ctrl.activity.contact = $ctrl.contact.name;
								}
							});
						}
					}
				});
			}
		});
	}

	selectContact() {
		const $ctrl = this;
		$ctrl.contacts.results.forEach(function (contact) {
			if (contact.name === $ctrl.activity.contact) {
				$ctrl.contact = contact;
				$ctrl.activity.contact = $ctrl.contact.name;
			}
		});
	}

	createActivity() {
		let $ctrl = this;
		let customer = {
			id: $ctrl.retailerId
		};
		ActivityPrompt.open({ model: { customer: customer } }).then(() =>
			$ctrl.activities.load(true)
		);
	}

	areTagsPopulated() {
		let $ctrl = this;
		var ret = true;
		if ($ctrl.orderConfig.orderQuestionsRequiredTagKinds) {
			if (!$ctrl.customer.tags) ret = false;
			$ctrl.orderConfig.orderQuestionsRequiredTagKinds.forEach(function (tagKind) {
				if (!$ctrl.customer.tags[tagKind]) ret = false;
			});
		}
		return ret;
	}
	save() {
		let $ctrl = this;
		$ctrl.errorMessage = "";
		$ctrl.bus.validationErrors = [];
		if ($ctrl.customer) {
			if ($ctrl.orderConfig.orderQuestionsRequiredTagKinds && !$ctrl.areTagsPopulated()) {
				$ctrl.errorMessage = "Please answer all questions and schedule follow-up";
				return;
			}
			const tags = $ctrl.customer.tags;
			const req = {
				shard: "Retailer",
				principalId: $ctrl.retailerId,
				tags: {}
			};

			for (const kind in tags) {
				if (tags[kind]) {
					if (Array.isArray(tags[kind])) req.tags[kind] = tags[kind];
					else req.tags[kind] = [tags[kind]];
				}
			}
			console.debug("BL*** req.tags", req.tags);
			if (req.tags && Object.keys(req.tags).length > 0) {
				$ctrl.bus.send("SaveTags.json", req).then(function (response) {
					if ($ctrl.orderConfig.orderQuestionsHideActivity || $ctrl.activity || $ctrl.orderConfig.dontRequireFollowup) {
						$ctrl.$close();
					}
				});
			} else {
				if ($ctrl.orderConfig.orderQuestionsHideActivity || $ctrl.activity || $ctrl.orderConfig.dontRequireFollowup) {
					$ctrl.$close();
				}
			}
		}
	}
}

export default OrderQuestionsPromptController;
